import { Subscription } from 'rxjs';
import { Component } from '@angular/core';
import { WebSiteUsersService } from '@app/services/webSiteUsers/webSiteUsers.service';
import { Router } from '@angular/router';
import { OrdersService } from '@app/services/order/orders.service';

@Component({

    selector: 'checkout',
    templateUrl: 'checkout.component.html',
    styleUrls: ['checkout.component.scss']
})
export class CheckoutComponent {
    isAuthenticated: boolean = false;
    activestep = 3;
    subscriptions: Subscription[] = [];
    constructor(
        private webSiteUsersService: WebSiteUsersService,
        private orderService: OrdersService,
        public router:Router
    ) {
        let sub = this.webSiteUsersService.listener.subscribe(
            log => {
                this.isAuthenticated = log
            }
        )
        let sub1=this.orderService.order.subscribe(
            (order) => {
                if (order.elementsNbr == 0) {
                    // this.router.navigate(['/carte'])
                }
            }
        )
        this.subscriptions.push(sub,sub1);
    }
    next() {
        if (this.activestep == 1) {
            this.activestep = (this.isAuthenticated) ? 3 : 2
        } else {
            this.activestep = 3;
        }
    }
    goToSummary(){
            this.router.navigate(['/checkout/summary']);
    }
    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }
    ngOnDestroy() {
        this.unsubscribe();
    }
}
